import { useContext, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthContext } from "./context/AuthContext";
import PublicLayout from "./layouts/PublicLayout";
import SuperAdminLayout from "./layouts/SuperAdminLayout";
import UserLayout from "./layouts/UserLayout";
import AdminLayout from "./layouts/AdminLayout";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ScrollTop from "./components/ScrollTop";

function App() {
  const { user, loading } = useContext(AuthContext);
  const queryClient = new QueryClient();

  useEffect(() => {
    const handleKeyDown = (e) => {

      if (e.key === "F12") {
        e.preventDefault();
      }

      if (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key)) {
        e.preventDefault();
      }
      if (e.ctrlKey && e.key.toLowerCase() === "u") {
        e.preventDefault();
      }

      if (e.ctrlKey && e.key.toLowerCase() === "s") {
        e.preventDefault();
      }
    };

    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    document.addEventListener("keydown", handleKeyDown);
    // document.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <h1>Loading...</h1>
      </div>
    );
  }

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <ScrollTop />
        <Routes>
          {!user ? (
            <Route path="/*" element={<PublicLayout />} />
          ) : user.role === "super_admin" ? (
            <Route path="/*" element={<SuperAdminLayout />} />
          ) : user.role === "admin" ? (
            <Route path="/*" element={<AdminLayout />} />
          ) : (
            <Route path="/*" element={<UserLayout />} />
          )}
          {/* This catch-all is now more effective */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </QueryClientProvider>
    </>
  );
}

export default App;
